import React, { useState } from 'react';

interface ThumbnailImageProps {
  image: any;            // the thumbnail URL (…_thumbnail.jpg)
  originalUrl?: string;  // the ORIGINAL image URL (carousel src) — reported for regeneration
  onMissing?: (originalUrl: string) => void;
  index: number;
  tag?: string;
  selectedImageIndex: number;
  handleGoTo: (index: number) => void;
}

const ThumbnailImage = React.forwardRef<HTMLImageElement, ThumbnailImageProps>(
  ({ image, originalUrl, onMissing, index, tag, selectedImageIndex, handleGoTo }, ref) => {
    const isSelected = selectedImageIndex === index;
    const [hasError, setHasError] = useState(false);

    const handleImageError = () => {
      if (hasError) return;
      setHasError(true);
      // Report the miss up to the slider, which batches all missing images from
      // this carousel into one /thumbnails request (SQS fan-out on the backend).
      // We just show the placeholder; the regenerated thumbnail appears on a
      // later load (generation is async).
      if (originalUrl) onMissing?.(originalUrl);
    };

    const sharedStyles: React.CSSProperties = {
      height: isSelected ? '95%' : '80%',
      aspectRatio: '16 / 9',
      border: isSelected ? '1.5px solid var(--ums-accent-red)' : '1px solid transparent',
      borderRadius: 4,
      cursor: 'pointer',
    };

    return !hasError && image ? (
      <img
        ref={ref}
        src={image}
        alt={`Selector ${index}`}
        onClick={() => handleGoTo(index)}
        onError={handleImageError}
        draggable={false}
        data-cy={`carousel-thumbnail-${index}`}
        data-selected={isSelected ? 'true' : 'false'}
        style={{
          ...sharedStyles,
          objectFit: 'cover',
        }}
      />
    ) : (
      <div
        onClick={() => handleGoTo(index)}
        draggable={false}
        data-cy={`carousel-thumbnail-${index}`}
        data-selected={isSelected ? 'true' : 'false'}
        style={{
          ...sharedStyles,
          backgroundColor: 'white',
          color: '#666',
          fontSize: '0.75rem',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: 500,
          textAlign: 'center',
          padding: '4px',
        }}
      >
        <div>No Thumbnail</div>
        {tag && <div style={{ marginTop: 1, fontSize: '0.75rem', color: '#aaa' }}>{tag}</div>}
      </div>
    );
  }
);

export default ThumbnailImage;
